export default "__VITE_ASSET__cec06cee__"